import { defineStore } from "pinia";

export const useLoaderStore = defineStore("loaderStore", {
  state: () => ({
    load: false, // Initialisiert mit false, um das Laden nicht sofort anzuzeigen
    message: "Ihre Anfrage wird verarbeitet.", // Standardfehlermeldung
  }),
  actions: {
    setLoader(load, message = "") {
      this.load = load;
      // Verwende die übergebene Nachricht, falls vorhanden, sonst behalte die aktuelle Nachricht bei
      if (message) this.message = message;
      if (message == '') this.message = "Ihre Anfrage wird verarbeitet.";
    },
    clearLoader() {
      this.load = false; // Setzt `load` auf false statt auf null
      this.message = "Ihre Anfrage wird verarbeitet."; // Setze die Nachricht zurück auf den Standardwert
    },
  },
});
